document.documentElement.className = document.documentElement.className.replace(/\bno-js\b/g, "") + "js"

if (window.location.hash) { setTimeout(function () { 
    var target = window.location.hash;
    var $target = jQuery(target);

    if($target == "#") return;

    jQuery('html, body').stop().animate({
        'scrollTop': $target.offset().top - 50
    }, 1200, 'swing', function () {
        window.location.hash = target;
    });
    
 }, 2); }

jQuery(document).ready(function ($) {

    /*-----------------------------------------------------------------------------GLOBAL ON LOAD----*/
	
	var lazyLoadInstance = new LazyLoad();

    //Load images, and images after doc ready
    var lazyLoadItems = (function () {
		
        
        var $lazyItems = $('img[data-src]:not(.lazy), iframe[data-src], script[data-src], [data-background]');
		
        if (!$lazyItems.length) { return; }

        function init() {
            console.log("lazy loaded");
            $lazyItems.each(function () {
                var $this = $(this),
                    delay = 0,
                    dataSrc;
                if (dataSrc = $this.data('background')) {
                    if ($this.data('background-delay')) {
                        delay = $this.data('background-delay');
                    }
                    setTimeout(function () {
                        $this.css('background-image', 'url(' + dataSrc + ')');
                        $this.attr('data-background', null);
                    }, delay);
                } else if (dataSrc = $this.data('src')) {
                    if ($this.data('src-delay')) {
                        delay = $this.data('src-delay');
                    }
                    setTimeout(function () {
                        $this.attr('src', dataSrc);
                        $this.attr('data-src', null);
                        $this.attr('srcset', dataSrc);
                        $this.attr('data-srcset', null);
                    }, delay);
                }
            });
        }
		
        init();
        return { init: init }
		
    }());

    //Global function to toggle simple accordions
    var Accordions = (function () {
        var $accordions = $('.accordion');
        if (!$accordions.length) { return; }

        $accordions.each(function () {
            $this = $(this).find('.accordion__trigger');
            
            if ($this.hasClass('active')) {
                $this.next().slideToggle(250);
            }
        });
        
        $(document).on('click', '.accordion__trigger', function (e) {
            var $this = $(this);
            if($(window).width() < 960 && $this.hasClass('has-link')) e.preventDefault();
            if($(window).width() > 960 && $this.hasClass('has-link')) return;

            $this.toggleClass('active');
            $this.next().slideToggle(250);
            $this.parent().siblings().find('.accordion__trigger').removeClass('active').next().slideUp(250);
        });
    }());

    var Forms = (function () {
        var InputMasks = (function () {
            var $masks = $('[data-mask]');
            if ( !$masks.length ) { return; }

            /**
             * Key Codes:
             * 8    - backspace
             * 13   - enter
             * 16   - shift
             * 18   - alt
             * 20   - caps
             * 27   - esc
             * 37   - left arrow
             * 38   - up arrow
             * 39   - right arrow
             * 40   - down arrow
             * 46   - delete
             **/
            var exclude_keys = [ 8, 13, 16, 18, 20, 27, 37, 38, 39, 40, 46 ];

            $( '[data-mask]' ).keyup( function ( e ) {
                console.log( e.keyCode );
                if ( exclude_keys.indexOf( e.keyCode ) > -1 ) { return; }

                switch ( this.dataset.mask ) {
                    case 'digits':
                        var x = this.value.replace( /\D/g, '' );
                        this.value = x;
                        break;
                    case 'phone':
                        var x = this.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                        console.log(x);
                        this.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
                        break;
                    case 'ssn': {
                        var x = this.value.replace(/\D/g, '').match(/^(\d{0,3})(\d{0,2})(\d{0,4})/);
                        this.value = !x[2] ? x[1] : x[1] + '-' + x[2] + '-' + x[3];
                    }
                }
            });
        }());

        //Plugin used for form validation
        var parselyOptions = {
            classHandler: function (parsleyField) {
                var $element = parsleyField.$element;
                if ($element.parent().hasClass('select-menu')) {
                    return $element.parent();
                }
                return $element;
            },
            errorsContainer: function (parsleyField) {
                var $element = parsleyField.$element;
                var $fieldContainer = $element.closest('.form-field');
                if ($fieldContainer) {
                    return $fieldContainer;
                }
            }
        };

        //Global function to set form state classes
        var formStates = (function () {
            $formInputs = $('main form :input');
            if (!$formInputs.length) { return; }

            $formSelectMenus = $('.select-menu select, .ginput_container_select select');

            function isGFormInput($el) {
                return $el.hasClass('ginput_container') ? $el.parent() : $el;
            }

            function setFilled($input) {
                var $parent = isGFormInput($input.parent());

                $parent.addClass('filled');
            }

            function removeFilled($input) {
                var $parent = isGFormInput($input.parent());

                $parent.removeClass('filled');
            }

            function setFocused() {
                var $parent = isGFormInput($(this).parent());

                $parent.addClass('focused');
            }

            function removeFocused() {
                var $parent = isGFormInput($(this).parent());

                $parent.removeClass('focused');
            }

            function checkInput(e) {
                if (this.type == 'button' ||
                    this.type == 'range' ||
                    this.type == 'submit' ||
                    this.type == 'reset') { return; }

                var $this = $(this);
                var $parent = $this.parent();
                var is_selectMenu = $parent.hasClass('select-menu') || $parent.hasClass('ginput_container_select');

                var $input = is_selectMenu ? $parent : $this;

                switch (this.type) {
                    case 'select-one':
                    case 'select-multiple':
                        if (this.value !== '') {
                            setFilled($input);
                        } else {
                            removeFilled($input);
                        }
                        break;
                    default:
                        if (this.value) {
                            setFilled($input);
                        } else {
                            removeFilled($input);
                        }
                        break;
                }
            }

            $formInputs.each(checkInput);
            $formInputs.on('change', checkInput);
            $formInputs.on('focus', setFocused);
            $formInputs.on('blur', removeFocused);
            $formSelectMenus.on('focus', setFocused);
            $formSelectMenus.on('blur', removeFocused);

        }());
    }());

    //Global function top open / close lightboxes
    var PDMLightbox = (function () {
		
		var $body = $('body');
        //Lightbox reset - This lightbox is empty and present on all pages
        var $lightbox = $('.pdm-lightbox--reset');
        var $formbox = $('.pdm-lightbox--form');

        //it's content can be filled from various sources
        //after close, the content is wiped
        var $lightbox_content = $('.pdm-lightbox--reset .pdm-lightbox__content');

        $body.on('click', '[data-lightbox-iframe],[data-lightbox-content],[data-lightbox-target], .lightbox-trigger', function (e) {

            e.preventDefault();

            if($(this).hasClass("lightbox-trigger")){
                console.log("lightbox trigger")
                $formbox.addClass("active");
                $lightbox = $formbox;
            }else{
                $lightbox = $('.pdm-lightbox--reset');
            }

			var classes = $(this).data('lightbox-classes');
            var iframe = $(this).data('lightbox-iframe');
            var blur = $(this).data('lightbox-blur');

            if (iframe) {
				
				var youtubePattern = /(?:http?s?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=)?(.+)/g;
				var vimeoPattern = /(?:http?s?:\/\/)?(?:www\.)?(?:vimeo\.com)\/?(.+)/g;
				
				if(youtubePattern.test(iframe)){
					
                    classes += ' youtube-vid'
					
                    replacement = '<div class="spacer"><iframe width="560" height="315" frameborder="0" allowfullscreen src="//www.youtube.com/embed/$1?autoplay=1&modestbranding=1&rel=0&iv_load_policy=3" /></div>';
					
					iframe = iframe.replace(youtubePattern, replacement);
										
                }
				
				if(vimeoPattern.test(iframe)){
					
                    classes += ' vimeo-vid'
					
                    replacement = '<div class="spacer"><iframe width="560" height="315" frameborder="0" allowfullscreen src="//player.vimeo.com/video/$1?autoplay=1&modestbranding=1&rel=0&iv_load_policy=3" /></div>';
					
					iframe = iframe.replace(vimeoPattern, replacement);

                }
				
				$lightbox_content.html('<div class="iframe-wrap">' + iframe + '</div>');

            } else {
                if ($(this).data('lightbox-content')) {
                    var content = $(this).data('lightbox-content');
                } else if ($(this).data('lightbox-target')) {
                    var target = $(this).data('lightbox-target');
                    var content = $('#' + target).html();
                }
                $lightbox_content.html(content);
            }

			if( blur != false ){
				$body.addClass('blur');
			}
			
            $lightbox.addClass('active').addClass(classes);

        });

        function closeLightbox($lightbox) {
            $lightbox.removeClass('active');
            $('body').removeClass('noScroll');
			setTimeout(function () {
				$body.removeClass('blur');
			}, 250);
            //wait before removing classes till lightbox closses
            if ($lightbox.hasClass('pdm-lightbox--reset')) {
                setTimeout(function () {
                    $lightbox.find('.pdm-lightbox__content').empty();
                    $lightbox.attr('class', 'pdm-lightbox pdm-lightbox--reset');
                }, 750);
            }
        }

        $('.pdm-lightbox').on('click', function (e) {
            var $lightbox = $(this);
            if (e.target == this) {
                closeLightbox($lightbox);
            }
        });

        $('.pdm-lightbox__close').click(function (e) {
            e.stopPropagation();
            $lightbox = $(this).closest('.pdm-lightbox');
            closeLightbox($lightbox);
        });
        return {
            close: closeLightbox
        };
    }());


    //******************************************************Everything under this is optional, feel free to delete
	
	
    var Header = (function () {
        var $body = $('body');
        var $header = $('header.gheader');
        var $nav = $header.find('nav.global');

        // $('.search-toggle.desk-only, .close-search').click(function(){
			
		// 	$('.search-form.desk-only').fadeToggle();
		// 	$('.search-form.desk-only input').focus();
			
		// });

        var BurgerMenu = (function () {
            var $burgerMenu = $header.find('.menu-burger');
            var $text = $burgerMenu.find('.menu-burger__text');

            function activate() {
                $burgerMenu.addClass('active').attr('title', 'Close');
                $text.text('Close');
                $nav.addClass('active');
                $body.addClass('no-scroll');
            }

            function reset() {
                $burgerMenu.removeClass('active').attr('title', 'Menu');
                $text.text('Menu');
                $nav.removeClass('active').find('.active').removeClass('active');
                $body.removeClass('no-scroll');
            }

            $burgerMenu.click(function () {
                var $this = $(this);

                if ($this.hasClass('active')) { reset(); } else { activate(); }
            });
        }());



        var DropdownMenus = (function () {
            var $menus = $('.menu');
            var $dropmenus = $menus.find('.dropdown.menu-item');
            var $mobileArrow = $dropmenus.find('.mobile-arrow');

            function toggleDropdown(e) {
                e.preventDefault();

                var $this = $(this);
                var $menuItem = $this.closest('.dropdown');

                $dropmenus.not($menuItem).removeClass('active');

                if ($menuItem.hasClass('active')) {
                    $menuItem.removeClass('active');
                } else {
                    $menuItem.addClass('active');
                }
            }

            $mobileArrow.click(toggleDropdown);
        }());

        var MenuDropdown = (function(){
            var mobileArrow = $("header .mega-menu-row .mega-indicator");

            mobileArrow.click(function(){
                console.log("click");
            });
        }());
    }());

    var SearchPop = (function () {
        var $body = $("body");
        var $toggleSearch = $('.search-toggle');
        var $searchPop = $('.searchpop');
        var $closePop = $('.searchpop__close');

        $searchPop.on('click', function (e) {
            
            if (e.target == this) {
                $searchPop.removeClass('active');
                $body.removeClass('noScroll');
            }
        });

        $closePop.click(function () {
            $searchPop.removeClass('active');
            $body.removeClass('noScroll');
        });

        $toggleSearch.click(function () {
            $searchPop.addClass('active');
            $body.addClass('noScroll');
            console.log("clicked search");
        });

        function getHeaderHeight() {
            $header = $('.gheader');
            $adminbar = $('#wpadminbar');

            return $adminbar.length ? parseInt($header.height() + $adminbar.height()) : parseInt($header.height());
        }
    }());
	
	

    var LoadMore = (function () {
        var $loadmore = $('#loadmore');
        if (!$loadmore.length) { return; }

        var $loadmore_text = $loadmore.text();

        $loadmore.click(function () {
            var $this = $(this);
            var $postlist = $this.closest('.blog-content').find('.post-list');

            var query = $this.attr('data-query');
            var page = parseInt($this.attr('data-page'));
            var max = parseInt($this.attr('data-max'));
            var postType = $this.attr('data-type');
            // console.log("post type is " + postType);

            var data = {
                action: 'load_more_posts',
                query: query,
                page: page,
                type: postType
            };

            $.ajax({
                url: ajaxURL,
                type: 'post',
                data: data,
                beforeSend: function () {
                    $loadmore.attr('disabled', true).text('Loading Posts');
                },
                error: function (res) {
                    res = JSON.parse(res);
                    console.log(res);
                },
                success: function (res) {
                    res = JSON.parse(res);
                    var current_page = res.page;
                    var posts = res.posts;

                    if (res.status !== 'error') {
                        $loadmore.attr('disabled', false).text($loadmore_text);
                        $this.attr('data-page', current_page);
                        $postlist.append(posts);
                        // console.log(posts);
                        // lazyLoadItems.init();
                        // lazyLoadImages.init();
                        lazyLoadInstance = new LazyLoad();

                    } else {
                        $loadmore.remove();
                    }

                    if (current_page >= max) {
                        $loadmore.remove();
                    }
                }
            });
        });
    }());

    IconSlider = (function(){
        // $(".icon-row .icon-row__grid").slick({
        //     arrows: false,
        //     slidesToShow: 4,
        //     slidesToScroll: 1,
        //     autoplay: true,
        //     autoplaySpeed: 2000
        //   });

          $sliders = $(".icon-row .icon-row__grid");

		if (!$sliders.length) {
			return;
		}

		$sliders.each(function () {
			$(this).flickity({
				prevNextButtons: false,
				pageDots: false,
				cellAlign: "left",
				wrapAround: false,
				contain: true,
                autoPlay: true,
                wrapAround: true,
                imagesLoaded: true,
                
			});

		});

        setTimeout(function() {
            $('.icon-row__grid .icon').css("height", "100%");
        }, 50);

        
    }());


    ProjectGallery = (function(){

        $sliders = $(".project-intro .project-intro__gallery");

		if (!$sliders.length) {
			return;
		}

        $sliders.each(function () { 
            $(this).slick();
        });

    }());

    ProjectTabs = (function(){
        $('.project-tabs .project-tabs__tab').hide();
        $('.project-tabs .project-tabs__tab:first-of-type ').show();
        $('.project-tabs .project-tabs__nav button:first-of-type ').addClass('active');
        var tabID;

        if(window.location.hash){
            switchTabs();
        }

        $("body").on("click", ".mega-menu-link", function(){
            setTimeout(function(){
                switchTabs();
            }, 50);
            
            console.log("menu link click");
        })

        function switchTabs(){
            var hash = window.location.hash;
            console.log(hash);
            // $(".project-tabs__nav button" + hash + "").addClass('active');
            
            if($(".project-tabs__nav button" + hash + "")){
                $(".project-tabs__nav button").removeClass("active");
                $(".project-tabs__nav button" + hash + "").addClass('active');

                tabID = $(".project-tabs__nav button" + hash + "").data('tab');
                console.log("tab id " + tabID);
                $(".project-tabs").closest(".project-tabs").find('.project-tabs__tab').hide();
                $(".project-tabs").closest(".project-tabs").find('.project-tabs__tab[data-tab-panel="' + tabID + '"]').show();

            }
        }

        $('.project-tabs .project-tabs__nav button').click(function(){
            $(".project-tabs__nav button").removeClass("active");
            $(this).addClass("active");
            
            tabID = $(this).data('tab');
            $(this).closest(".project-tabs").find('.project-tabs__tab').hide();
            $(this).closest(".project-tabs").find('.project-tabs__tab[data-tab-panel="' + tabID + '"]').show();
        });
    }());


    var ReadMore = (function() {
        var readMoreBtn = $('.read-more-btn');

        readMoreBtn.click(function(){
            var $section = $(this).closest('section');
            $section.find(".read-more-text").slideToggle();
        });
    }());

    // var lazyLoadImages = (function () {
    //     var $lazyImages = $('img[data-src], iframe[data-src], [data-background]');
    //     if (!$lazyImages.length) { return; }

    //     function init() {
    //         console.log("second lazy load");
    //         $lazyImages.each(function () {
    //             var $this = $(this),
    //                 delay = 0,
    //                 dataSrc;
    //             if (dataSrc = $this.data('background')) {
    //                 if ($this.data('background-delay')) {
    //                     delay = $this.data('background-delay');
    //                 }
    //                 setTimeout(function () {
    //                     $this.css('background-image', 'url(' + dataSrc + ')');
    //                     $this.attr('data-background', null);
    //                 }, delay);
    //             } else if (dataSrc = $this.data('src')) {
    //                 if ($this.data('src-delay')) {
    //                     delay = $this.data('src-delay');
    //                 }
    //                 setTimeout(function () {
    //                     $this.attr('src', dataSrc);
    //                     $this.attr('data-src', null);
    //                 }, delay);
    //             }
    //         });
    //     }
    //     init();
    //     return { init: init }
    // }());

    var ImageGallery = (function(){
        $sliders = $(".content-gallery .content-gallery__slider");

        if (!$sliders.length) {
			return;
		}

        $sliders.each(function () { 
            $(this).slick({
                dots: true,
                arrows: false
            });
        });

    }());

   /* var Leadform = (function(){
        var sizeRecaptcha = function () {
            var reCaptchaWidth = 304;
            var formWidth = $("#leadForm").width();

            if (reCaptchaWidth > formWidth) {
                return 'compact';
            }
            return 'normal';
        };
        var initRecaptcha = function () {
            $("#recaptchaContainer").empty().append('<div id="recaptcha"></div>');
            grecaptcha.render('recaptcha', { sitekey: '6Le7WMUcAAAAAIqDlw2-ZIIYzBZCZTwPAA8ktx_V', size: sizeRecaptcha() });
        };
        $(window).resize(initRecaptcha);
        $(document).ready(function () {
            $("#leadCountry").change(function () {
                var label = 'Region *';
                switch ($(this).val()) {
                    case 'US':
                        label = 'State *';
                        break;
                    case 'CA':
                        label = 'Province *';
                        break;
                }
                $("#leadStateLabel").text(label);
            });
            $("#leadCategory").change(function () {
                $("#leadProfession option:not(:first)").hide();
                $("#leadProfession").val('').trigger('change');
                $("#leadProfession").removeAttr('required');
                if ($(this).val() && 'homeowner' !== $(this).val()) {
                    $("#leadProfession").attr('required', 'required');
                    $("#leadProfession option." + $(this).val()).show();
                    $("#leadProfessionFormGroup").slideDown();
                } else {
                    $("#leadProfessionFormGroup").slideUp();
                }
            });
            $("#leadProfession").change(function () {
                $("#leadProfessionCustom").val('');
                $("#leadProfessionCustom").removeAttr('required');
                if ($(this).val() && 'Other' === $(this).val()) {
                    $("#leadProfessionCustom").attr('required', 'required');
                    $("#leadProfessionCustom").show();
                    $("#leadProfession").css('width', '40%');
                } else {
                    $("#leadProfessionCustom").hide();
                    $("#leadProfession").css('width', '100%');
                }
            });
            $("#leadForm :input").on('input', function () {
                if ($(this).val()) {
                    $(this).closest(".form-group").removeClass('has-error');
                }
            });
            $("#leadForm").submit(function (event) {
                event.preventDefault();

                $("#leadFormButton").attr('disabled', 'disabled');

                var hasErrors = false;
                $(".lead-form-message").stop(true).hide();
                $(this).find(".has-error").removeClass('has-error');
                $(this).find(":input[required]").each(function () {
                    if (!$(this).val()) {
                        $(this).closest(".form-group").addClass('has-error');
                        hasErrors = true;
                    }
                });

                if (hasErrors) {
                    $("#leadRequiredMessage").fadeIn().delay(5000).fadeOut();
                    $("#leadFormButton").removeAttr('disabled');
                    return false;
                }

                var country = $("#leadCountry").val();
                $.post('/lead', $(this).serialize(), function (data) {
                    
                    $("#leadForm").trigger('reset');
                    $("#leadCountry").val(country);
                    $("#leadSuccessMessage").fadeIn().delay(5000).fadeOut();
                }).fail(function (error) {
                    $("#leadErrorMessage").fadeIn().delay(5000).fadeOut();
                }).always(function () {
                    initRecaptcha();
                    $("#leadFormButton").removeAttr('disabled');
                });
            });
        });
    }());*/



    AOS.init({
        delay: 250,
        once: true,
        disable: 'mobile'
    });

});